
import Button from './Button'
import classes from './ButtonM.module.css'
import { forwardRef } from 'react'

const ButtonM = forwardRef(({type = 'button', loading, children, isDelete, onClick, disabled, className, 'data-testid': testId}, ref) => {
    return (
        <Button 
            ref={ref}
            className={`${classes['btn-m']}  ${className}`} 
            type={type} 
            onClick={onClick} 
            disabled={disabled} 
            loading={loading}
            delete={isDelete}
            data-testid={testId}>
            {children}
        </Button>
    )
})

export default ButtonM